var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"tiny-button",class:( _obj = {}, _obj[_vm.type] = _vm.type !== '', _obj[_vm.size] = _vm.size !== '', _obj['icon'] =  _vm.icon, _obj ),attrs:{"disabled":_vm.disabled,"type":_vm.htmlType},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }